/**
 * ObjectChip — generic clickable pill for any of the 9 ObjectKinds, icon +
 * colour from KIND_META. Parallel to EntityChip (kept as-is for its
 * domain-dot-coloured entity-only lists) — this is the cross-kind version
 * used by RelatedObjectsChips and, later, search/trail results.
 *
 * @see docs/superpowers/specs/2026-08-10-atlas-feature-flag-relationships-design.md Part 3
 */
import type { JSX } from 'react';
import { Icon } from './Icon.js';
import { KIND_META, type ObjectKind } from '../state/objectKinds.js';

export interface ObjectChipProps {
  kind: ObjectKind;
  id: string;
  /** Human-readable relation label, e.g. 'gated by' — shown in the tooltip only. */
  relation?: string;
  onClick: (kind: ObjectKind, id: string) => void;
}

export function ObjectChip({ kind, id, relation, onClick }: ObjectChipProps): JSX.Element {
  const meta = KIND_META[kind];
  return (
    <button
      type="button"
      className="object-chip"
      title={relation ? `${relation} → ${id}` : id}
      onClick={() => onClick(kind, id)}
    >
      <Icon name={meta.icon} size="sm" color={meta.color} />
      <span className="object-chip-label">{id}</span>
    </button>
  );
}
